'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import type { ComponentProps } from 'react';
import { scrollToTop } from '@/lib/scroll-to-top';
import { useReducedMotion } from '@/lib/use-reduced-motion';

type HomeLogoLinkProps = ComponentProps<typeof Link>;

function normalizePath(path: string) {
  const withoutHash = path.split('#')[0] || '/';
  const withoutQuery = withoutHash.split('?')[0] || '/';
  return withoutQuery === '' ? '/' : withoutQuery;
}

export function HomeLogoLink({ href = '/', onClick, ...props }: HomeLogoLinkProps) {
  const pathname = usePathname();
  const prefersReducedMotion = useReducedMotion();

  return (
    <Link
      href={href}
      {...props}
      onClick={(event) => {
        onClick?.(event);
        if (event.defaultPrevented) return;
        if (
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey ||
          event.button !== 0
        ) {
          return;
        }

        if (typeof href !== 'string') return;

        if (pathname === normalizePath(href)) {
          event.preventDefault();
          scrollToTop(prefersReducedMotion ? 'auto' : 'smooth');
        }
      }}
    />
  );
}
